<template>
    <div class="container">
        <div class="inner">
            <div class="title page-title">
                <h3>KDA란?</h3>
            </div>
            <div class="kda-wrap">
                <div class="kda-item1">
                    <img src="/src/assets/images/kda_bg.png" />
                    <div class="item-inner">
                        <div>
                            <h5>VISION</h5>
                            <p>
                              산업계가 요구하는<br/>
                              실무형 인재 양성으로<br/>
                              글로벌 디스플레이 초격차<br/>
                              전략의 중추 역할
                            </p>
                        </div>
                        <div>
                            <h5>GOAL</h5>
                            <p>
                              차세대 기술 선도<br/>
                              디스플레이 인력양성 및<br/>
                              인재 관리 체계화
                            </p>
                        </div>
                    </div>
                </div>
                <div class="kda-item2">
                    <h4>한국디스플레이아카데미 추진방향</h4>
                    <div class="item-inner">
                        <div>
                            <img src="/src/assets/images/kda_img1.png" />
                            <b>융합</b>
                            <p>
                              디스플레이를 넘어<br/>
                              다양한 응용 산업으로의 연계
                            </p>
                        </div>
                        <div>
                            <img src="/src/assets/images/kda_img2.png" />
                            <b>실무</b>
                            <p>
                              산업 현장과 실시간으로<br/>
                              호흡하는 실무 중심 커리큘럼
                            </p>
                        </div>
                        <div>
                            <img src="/src/assets/images/kda_img3.png" />
                            <b>교류</b>
                            <p>
                              산학연 협력 생태계와의<br/>
                              긴밀한 소통
                            </p>
                        </div>
                        <div>
                            <img src="/src/assets/images/kda_img4.png" />
                            <b>비전</b>
                            <p>
                              글로벌 트렌드를 이끄는<br/>
                              디스플레이 인재의 비전 제시
                            </p>
                        </div>
                    </div>
                </div>
                <div class="kda-item3">
                  <h4>아카데미 교육 개요</h4>
                  <img width="100%" src="/src/assets/images/kda_academy.jpg" alt="아카데미 교육 개요" />
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../../../../assets/scss/theme";

    .kda-wrap {
      h4 {
        @include font-size_xxl;
        margin-bottom: 38px;
      }
      .kda-item1 {
        position: relative;
        margin-bottom: 64px;
        .item-inner {
          position: absolute;
          display: flex;
          justify-content: space-between;
          align-items: center;
          top: 50%;
          left: 50%;
          max-width: 640px;
          width: 100%;
          transform: translate3d(-50%, -50%, 0);
          div {
            width: 280px;
            height: 280px;
            border-radius: 50%;
            background: rgba(0, 0, 0, 0.4);
            border: 1px solid rgba(0, 0, 0, 0.2);
            color: #fff;
            text-align: center;
            h5 {
              position: relative;
              @include font-size_xl;
              padding-bottom: 10px;
              margin-top: 58px;
              margin-bottom: 10px;
              &:after {
                content: "";
                position: absolute;
                left: 50%;
                bottom: 0px;
                width: 30px;
                height: 1px;
                background-color: #fff;
                transform: translateX(-50%);
              }
            }
          }
        }
      }
      .kda-item2 {
        margin-bottom: 106px;
        .item-inner {
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          div {
            margin-left:140px;
            &:first-child {
              margin-left: 0;
            }
            b {
              display: block;
              @include font-size_md;
              margin: 30px 0 10px;
            }
          }
        }
      }
    }

</style>
<script setup lang="ts">
</script>